import { storyblokEditable, StoryblokComponent } from "@storyblok/react/rsc";

import { Headline } from "@/components/typography/Headline";
import { RichTextField } from "@/components/typography/RichTextField";
import { ListBlock } from "@/components/layout/ListBlock";
import { GridContainer } from "@/components/layout/GridContainer";
import type { TextBlockStoryblok } from "@/component-types-sb";

type TextBlockProps = {
  blok: TextBlockStoryblok;
};

const TextBlock = ({ blok }: TextBlockProps) => {
  return (
    <GridContainer {...storyblokEditable(blok)}>
      <div className="col-span-12 md:col-span-8 md:col-start-3 lg:col-span-6 lg:col-start-4 flex flex-col gap-6 py-6">
      {blok.title && (
        <Headline as="h2" size="tall">
          {blok.title}
        </Headline>
      )}

      {blok.text && <RichTextField value={blok.text} className="text-copy" />}

      {blok.items && blok.items.length > 0 && (
        <ListBlock variant="subtle">
          {blok.items.map((nestedBlok) => (
            <StoryblokComponent key={nestedBlok._uid} blok={nestedBlok} />
          ))}
        </ListBlock>
      )}

      {blok.footer && <RichTextField value={blok.footer} className="text-copy" />}
      </div>
    </GridContainer>
  );
};

export default TextBlock;
